import { inject, Injectable } from '@angular/core';
import { MarketColumnDetail } from '@clean-code/models';
import { ID } from '@clean-code/models/common';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { MarketDashboardSignalStore } from '../+state/market-dashboard-signal.store';
import { MarketColumnDetailDataService } from '../infrastructure/column-detail.data.service';
import { MarketDashboardNormalizerService } from '../infrastructure/market-dashboard-normalizer.service';

@Injectable()
export class MarketColumnDetailFacade {
  private service = inject(MarketColumnDetailDataService);
  private store = inject(MarketDashboardSignalStore);
  private normalizer = inject(MarketDashboardNormalizerService);

  add$(input: MarketColumnDetail) {
    return this.service.add$(input).pipe(
      tap((value: MarketColumnDetail) => {
        const detailColumn = this.normalizer.normalizeDetailColumn({
          ...input,
          id: value.id,
        });

        this.store.upsertDetailColumn(detailColumn);
      }),
    );
  }

  update$(input: MarketColumnDetail) {
    return this.service.update$(input).pipe(
      tap((value: MarketColumnDetail) => {
        const detailColumn = this.normalizer.normalizeDetailColumn({
          ...input,
          id: value.id,
        });

        this.store.upsertDetailColumn(detailColumn);
      }),
    );
  }

  getAll$(columnId: ID): Observable<MarketColumnDetail[]> {
    return this.service.getAll$(columnId);
  }

  getById$(_id: ID) {
    return this.service.getById$(_id);
  }

  delete$(_id: ID) {
    return this.service
      .delete$(_id)
      .pipe(tap(() => this.store.removeDetailColumn(_id)));
  }
}
